import React from 'react';

import styles from './popover-content.scss';
import { Button } from '../button';

interface Props {
  dataHook: string;
  onClick: Function;
  children: React.ReactNode;
  isMenuItem?: boolean;
}

export const RoleActionLink: React.StatelessComponent<Props> = ({
  dataHook,
  onClick,
  children,
  isMenuItem = false,
}) => (
  <Button isMenuItem={isMenuItem} dataHook={dataHook} onClick={() => onClick()} className={styles.actionContainer}>
    {children}
  </Button>
);
